/* tslint:disable */
/* eslint-disable */
/**
 * referral-network
 * referral-network
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ListDirectoryContacts200Response,
    ListDirectoryContacts200ResponseFromJSON,
    ListDirectoryContacts200ResponseToJSON,
} from '../models/ListDirectoryContacts200Response';

export interface ListDirectoryContactsRequest {
    /**
     * The sender facility requesting the picker, used for access control
     */
    senderFacilityId: number;
    /**
     * The recipient provider whose contacts to list
     */
    providerId: string;
    /**
     * Which contact type to list (e.g. 'inbound' for the recipient picker)
     */
    contactType: ListDirectoryContactsContactTypeEnum;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Creates request options for listDirectoryContacts without sending the request
     */
    async listDirectoryContactsRequestOpts(requestParameters: ListDirectoryContactsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['senderFacilityId'] == null) {
            throw new runtime.RequiredError(
                'senderFacilityId',
                'Required parameter "senderFacilityId" was null or undefined when calling listDirectoryContacts().'
            );
        }

        if (requestParameters['providerId'] == null) {
            throw new runtime.RequiredError(
                'providerId',
                'Required parameter "providerId" was null or undefined when calling listDirectoryContacts().'
            );
        }

        if (requestParameters['contactType'] == null) {
            throw new runtime.RequiredError(
                'contactType',
                'Required parameter "contactType" was null or undefined when calling listDirectoryContacts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['senderFacilityId'] != null) {
            queryParameters['sender_facility_id'] = requestParameters['senderFacilityId'];
        }

        if (requestParameters['providerId'] != null) {
            queryParameters['provider_id'] = requestParameters['providerId'];
        }

        if (requestParameters['contactType'] != null) {
            queryParameters['contact_type'] = requestParameters['contactType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/referral-recipient-configs/contacts`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List a provider\'s directory contacts of a given type for the recipient contact picker
     */
    async listDirectoryContactsRaw(requestParameters: ListDirectoryContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListDirectoryContacts200Response>> {
        const requestOptions = await this.listDirectoryContactsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListDirectoryContacts200ResponseFromJSON(jsonValue));
    }

    /**
     * List a provider\'s directory contacts of a given type for the recipient contact picker
     */
    async listDirectoryContacts(requestParameters: ListDirectoryContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListDirectoryContacts200Response> {
        const response = await this.listDirectoryContactsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const ListDirectoryContactsContactTypeEnum = {
    Inbound: 'inbound',
    Outbound: 'outbound',
} as const;
export type ListDirectoryContactsContactTypeEnum = typeof ListDirectoryContactsContactTypeEnum[keyof typeof ListDirectoryContactsContactTypeEnum];
